import { jsx as _jsx } from "react/jsx-runtime";
import { TextHighlight } from '../../../common';
import { CatHeading } from '@blocks-react/components/Heading';
import styles from '../../MyEquipment.module.scss';
export const EquipmentName = ({ variant, textToHighlightTerm, text, isVirtualScroll = false, textColor }) => {
    return (_jsx("div", { slot: "trigger", className: `${styles['equipment-list--heading']}`, children: _jsx(CatHeading, { variant: variant, children: _jsx(TextHighlight, { text: text, textToHighlight: textToHighlightTerm, highlightClassName: `${textColor} text-truncate color-black d-block`, isVirtualScroll: isVirtualScroll, isSpecialCharacters: true }) }) }));
};
